import { twMerge } from 'tailwind-merge';
import { ClassName } from '@/types';

type IconProps = {
    name: string;
    filled?: boolean;
    className?: ClassName;
};

export const Icon = ({ name, filled = false, className }: IconProps)=> {
    return (
        <i className={twMerge('material-symbol select-none align-middle', filled && 'icon-style-filled', className)}>
            {name}
        </i>
    );
}
